function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3333 2.9375L12.3333 17L9.58333 17C7.01667 17 5 20.2944 5 24.5C5 28.7056 7.01667 32 9.58333 32L22.4167 32C24.9833 32 27 28.7056 27 24.5L27 18.875L22.4167 18.875L22.4167 17L27 17L27 13.25L22.4167 13.25L22.4167 11.375L27 11.375L27 7.625L22.4167 7.625L22.4167 5.75L27 5.75L27 2.9375C27 2.68886 26.9034 2.4504 26.7315 2.27459C26.5596 2.09877 26.3264 2 26.0833 2L13.25 2C13.0069 2 12.7737 2.09877 12.6018 2.27459C12.4299 2.4504 12.3333 2.68886 12.3333 2.9375ZM12.3333 24.5C12.3333 27.815 10.8841 30.125 9.58333 30.125C8.28258 30.125 6.83333 27.815 6.83333 24.5C6.83333 21.185 8.28258 18.875 9.58333 18.875C10.8841 18.875 12.3333 21.185 12.3333 24.5Z",
  fill: "current"
});

function SvgMeasurement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurement);
export default __webpack_public_path__ + "static/media/Measurement.9ac251e7.svg";
export { ForwardRef as ReactComponent };